import React, { ReactElement } from 'react';
import withOrderItems from './withOrderItems';

interface Props {
  orderItem: any;
  labelWithTariffPackage: string;
}

export const OrderItemDevice: React.FC<Props> = (props: Props): ReactElement => {
  const { orderItem, labelWithTariffPackage } = props;
  return (
    <React.Fragment>
      <img data-test-order-device-img src={orderItem.device.image} alt='Device'/>
      <div className={'d-inline-block text-start align-middle'}>
        <div className={'fw-bold'}>{orderItem.device.name}</div>
        <div>{labelWithTariffPackage}</div>
        <div className={'fw-bold'}>{orderItem.tariffPackage.name}</div>
      </div>
    </React.Fragment>
  );
};

export default withOrderItems(OrderItemDevice);
